/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    
    preview: {
        "& .ql-container": {
            minHeight: "auto",
        },
        "& .ql-editor": {
            padding: 0,
        },
    },
    disabled: {
        "& input.Mui-disabled": {
            "-webkit-text-fill-color": "#2d2d2d",
            backgroundColor: "#f4f4f4",
            paddingLeft: theme.spacing(1.5),
            color: "#2d2d2d",
        },
    },
    autoComplete: {
        "& .MuiAutocomplete-clearIndicator": {
            display: "none",
        },
    },
    boxContainer: {
        padding: theme.spacing(2),
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.spacing(0.5),
        display: "flex",
        justifyContent: "center",
        "& svg": {
            width: theme.spacing(2),
            height: theme.spacing(2),
            marginRight: theme.spacing(1),
        },
    },
    boxContainerFull: {
        padding: theme.spacing(3),
        // border: `1px solid ${theme.palette.grey[300]}`,
        // borderRadius: theme.spacing(0.5),
        display: "flex",
        width: "100%",
        justifyContent: "left",
        // padding: '20px',
        "& svg": {
            width: theme.spacing(2),
            height: theme.spacing(2),
            marginRight: theme.spacing(1),
        },
    },
    boxContainerFullCenter: {
        padding: theme.spacing(2),
        // border: `1px solid ${theme.palette.grey[300]}`,
        // borderRadius: theme.spacing(0.5),
        display: "flex",
        width: "100%",
        // height: '100%',
        justifyContent: "center",
        "& svg": {
            width: theme.spacing(2),
            height: theme.spacing(2),
            marginRight: theme.spacing(1),
        },
    },
    centerBox: {
        minHeight: "100px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    showLessBtn: {
        fontSize: "0.8em",
        padding: "1px 1em",
        paddingTop: "0.8em",
        fontWeight: "bold",
    },
    // stroke: {
    //     padding: `${theme.spacing(0.75)} 0`,
    //     color: '#b4b4b4',
    // },
    previewLabel: {
        "& .MuiTypography-root": {
            color: theme.palette.common.deepGrey,
            textTransform: "none",
            display: "block",
            marginBottom: theme.spacing(1),
        },
        "& .MuiFormHelperText-root": {
            textAlign: "right",
        },
    },
    
    //// Fields ////
    imageList: {
        // border: `1px solid red`,
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        gap: "20px",
        maxWidth: "100%",
        minHeight: 200,
    },
    noEmbedContent: {
        width: "100%",
        height: "100%",
        minHeight: 200,
        padding: "24px 32px",
        backgroundColor: "#CFCFCF",

        "& .preview": {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#fff",
            borderRadius: 4,
            fontSize: "0.75rem",
            color: "#999",
        },
    },
    iMaskInput: {
        border: "none",
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        margin: 0,
        padding: "10.5px 14px 10.5px 12px",
        display: "block",
        minWidth: 0,
        width: "92%",
        fontSize: "1rem",
    },
}));

export default useStyles;


//   MIGRATED to css already

// fieldEditorHeader: {
//     display: 'flex',
//     alignItems: 'center',
//     flexWrap: `wrap !important`,
//     '& p': {
//         flex: `0 0 100%`,
//         margin: 0,
//     },
// },
// subTitle: {
//     fontWeight: 600,
//         color: '#2d2d2d',
// },
// horizontalLine: {
//     width: theme.spacing(3),
//         height: 1,
//         display: 'inline-block',
//         borderTop: '1px solid #CFCFCF',
//         backgroundColor: 'transparent',
//         margin: 0,
//         marginTop: 5,
// },
// createBtnContainer: {
//     width: `100%`,
//         // position: `-webkit-sticky`,
//         position: `sticky`,
//         bottom: 0,
//         zIndex: 99,
//         backgroundColor: theme.palette.common.white,
//         padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
//         paddingBottom: theme.spacing(8),
//         // border: `1px solid ${theme.palette.common.lightGrey}`,
//         borderRadius: theme.spacing(1),
//         display: `flex`,
//         justifyContent: 'center',
//         border: `none`,
//         '& button': {
//         marginRight: theme.spacing(2),
//             '&:last-child': {
//             marginRight: 0,
//         },
//     },
//     '&.noBorder': {
//         border: `none`,
//             backgroundColor: theme.palette.text[5],
//     },
// },

// fieldsContainer: {
//     // border: `1px solid red`,
//     // paddingRight: theme.spacing(1.5),
//     '& p.field_text_h1, & p.field_number_h1, & p.field_enum_h1': {
//         margin: 0,
//         fontSize: `1.25rem`,
//         fontWeight: 500,
//         lineHeight: 2,
//         letterSpacing: 0.15,
//     },
//     '& p.field_text_h2, & p.field_number_h2, & p.field_enum_h2': {
//         margin: 0,
//         fontSize: `1.125rem`,
//         fontWeight: 700,
//         lineHeight: 1.5,
//         letterSpacing: 0.15,
//     },
//     '& p.field_text_h3, & p.field_number_h3, & p.field_enum_h3': {
//         margin: 0,
//         fontSize: `1rem`,
//         fontWeight: 700,
//         lineHeight: 1.5,
//         letterSpacing: 0.15,
//     },
// },


// //  Details Box
// detailsBoxArea: {
//     top: 0,
//     maxWidth: 250,
//     // position: `-webkit-sticky`,
//     position: `sticky`,
// },
// detailsBox: {
//     marginTop: theme.spacing(2),
//     paddingBottom: 0,
//     width: '100%',
//     border: `1px solid ${theme.palette.common.lightGrey}`,
//     borderRadius: theme.spacing(0.5),
//     backgroundColor: '#FFFFFF'
// },
// detailsBoxCodePanel: {
//     width: '200px',
//     height: '200px',
//     overflowX: 'auto',
//     fontSize: '8px',
//     backgroundColor: '#e8e8e8',
//     border: '1px solid rgba(220,220,220,1.0)',
//     // backgroundColor: 'rgba(240,240,240,1.0)',
//     color: 'rgba(128,128,128,1.0)',
//     // width: '100%',
//     maxWidth: '1024px',
//     minWidth: '100%',
//     // height: '300px',
//     overflow: 'auto',
//     // fontSize: '11px',
// },
// bannerImage: {
//     width: `100%`,
//     backgroundColor: `#f4f4f4`,
//     borderRadius: theme.spacing(0.5),
//     cursor: `pointer`,
//     '&.notFullWidth': {
//         width: `33.333%`,
//         minWidth: 200,
//     },
//     '& .simplicity-cover-image-thumb': {
//         '&.leftTop': {
//             backgroundPosition: `left top`,
//         },
//         '&.leftCenter': {
//             backgroundPosition: `left center`,
//         },
//         '&.leftBottom': {
//             backgroundPosition: `left bottom`,
//         },
//         '&.centerTop': {
//             backgroundPosition: `center top`,
//         },
//         '&.center': {
//             backgroundPosition: `center center`,
//         },
//         '&.centerBottom': {
//             backgroundPosition: `center bottom`,
//         },
//         '&.rightTop': {
//             backgroundPosition: `right top`,
//         },
//         '&.rightCenter': {
//             backgroundPosition: `right center`,
//         },
//         '&.rightBottom': {
//             backgroundPosition: `right bottom`,
//         },
//         '& .image-hover': {
//             display: `none`,
//             width: `100%`,
//             height: 135,
//             backgroundColor: `rgba(0,0,0,0.5)`,
//             position: `absolute`,
//             justifyContent: `center`,
//             alignItems: `center`,
//         },
//         '&:hover': {
//             '& .image-hover': {
//                 display: `flex`,
//             },
//         },
//         display: `flex`,
//         justifyContent: `center`,
//         alignItems: `center`,
//         fontSize: `0.8125rem`,
//     },
//     '& .outer': {
//         backgroundColor: `#f4f4f4`,
//         borderRadius: theme.spacing(0.5),
//         padding: theme.spacing(1),
//     },
//     '& .inner': {
//         width: `100%`,
//         borderRadius: theme.spacing(0.5),
//         backgroundColor: `#fff`,
//         display: `flex`,
//         justifyContent: `center`,
//         alignItems: `center`,
//         padding: `${theme.spacing(2.5)} 0`,
//         fontSize: `0.8125rem`,
//         color: theme.palette.primary.main,
//         '& svg': {
//             width: 16,
//             height: 16,
//             marginRight: theme.spacing(1),
//             '& path': {
//                 fill: theme.palette.primary.main,
//             },
//         },
//     },
//     '& .inner-image': {
//         padding: 0,
//         width: `75%`,
//     },
// },
// rightHandler: {
//     // border: `1px solid red`,
//     backgroundColor: '#F6F6F6',
//     width: '64px',
//     display: `flex`,
//     flexDirection: 'column',
//     justifyContent: `space-between`,
//     alignItems: 'center',
// },
// removeIcon: {
//     // border: `1px solid red`,
//     marginTop: theme.spacing(6),
//     display: `flex`,
//     margin: '16px',
//
//     alignItems: 'center',
//     cursor: `pointer`,
// },
// editorHeader: {
//     backgroundColor: '#fff',
//     paddingTop: theme.spacing(1.5),
//     paddingBottom: theme.spacing(3),
//     top: 0,
//     zIndex: 101,
//     display: `flex`,
//     flexWrap: `nowrap`,
//     justifyContent: 'space-between',
//     '& button': {
//         textWrap: 'nowrap',
//     },
// },
// pageTitle: {
//     color: '#7a7a7a',
//     fontWeight: 700,
//     marginBottom: theme.spacing(1),
//     paddingTop: theme.spacing(1),
//     '& p': {
//         fontSize: `1.5rem !important`,
//     },
// },
// editorButtons: {
//     backgroundColor: '#F4F4F4',
//     borderTop: `#ececec 1px solid`,
//     padding: `${theme.spacing(0.25)} ${theme.spacing(3)}`,
//     display: `flex`,
//     justifyContent: `space-between`,
//     flexWrap: `wrap`,
//     '& label': {
//         flex: `0 0 100%`,
//         '& .MuiTypography-body1': {
//             fontSize: `0.8125rem`,
//             color: `#666`,
//             fontWeight: 400,
//         },
//         '& .MuiSwitch-thumb': {
//             color: `#fff`,
//         },
//         '& .Mui-checked+.MuiSwitch-track': {
//             opacity: 1,
//         },
//     },
// },



// displaySettings: {
//     border: `none`,
//         width: `100%`,
//         // position: `sticky`,
//         bottom: 0,
//         backgroundColor: theme.palette.common.white,
//         display: `flex`,
//         flexDirection: 'column',
//         justifyContent: 'flex-start',
//         flexWrap: `wrap`,
//         '& .header': {
//         width: `100%`,
//             height: '1.7rem',
//             padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
//             backgroundColor: `#f4f4f4`,
//             fontSize: `0.75rem`,
//             letterSpacing: 0.25,
//             color: `#666`,
//             fontWeight: 500,
//             [theme.breakpoints.down('lg')]: {
//             maxWidth: `100%`,
//         },
//     },
//     '& button': {
//         marginRight: theme.spacing(2),
//     },
//     '&.noBorder': {
//         border: `none`,
//             backgroundColor: theme.palette.text[5],
//     },
//     '& .labelField': {
//         padding: theme.spacing(1.5),
//             '& span': {
//             color: `#2d2d2d`,
//                 textTransform: 'none',
//                 fontWeight: 500,
//                 fontSize: `0.875rem`,
//                 lineHeight: `1.3125rem`,
//                 letterSpacing: 0.15,
//         },
//     },
//     '& p': {
//         color: `#7a7a7a`,
//             fontSize: `0.875rem`,
//     },
// },
// dateInput: {
//     border: `1px solid ${theme.palette.grey[300]}`,
//         borderRadius: theme.spacing(0.5),
//         boxSizing: `content-box`,
//         background: `none`,
//         height: `1.4375em`,
//         margin: 0,
//         padding: `10.5px 14px 10.5px 12px`,
//         display: `block`,
//         minWidth: '300px',
//         width: `100%`,
//         '& .react-datepicker': {
//         fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
//     },
//     '& .react-datepicker__close-icon': {
//         right: `${theme.spacing(1.5)} !important`,
//     },
//     '& .react-datepicker__header': {
//         backgroundColor: `#fff`,
//     },
//     '& .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range':
//     {
//         borderRadius: 30,
//     },
// },
// defaultEmbedDiv: {
//     width: `100%`,
//     height: `100%`,
//     minHeight: 200,
//     padding: `24px 32px`,
//     backgroundColor: '#CFCFCF',
//     '& .preview': {
//         width: `100%`,
//         height: `100%`,
//         display: `flex`,
//         justifyContent: `center`,
//         alignItems: `center`,
//         backgroundColor: '#fff',
//         borderRadius: 4,
//         fontSize: `0.75rem`,
//         color: `#999`,
//     },
// },
// embedEditor: {
//     width: '100%',
//     height: 200,
//     border: '1px solid #343434',
//     background: '#dedede',
//     '& textarea': {
//         minHeight: 200,
//     },
// },
// embedPlaceholder: {
//     color: theme.palette.grey[400],
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     gap: `1rem`,
//     padding: `${theme.spacing(2.5)} 0`,
// },
// addButton: {
//     lineHeight: 1,
//         marginBottom: theme.spacing(2),
//         cursor: `pointer`,
//         '& svg': {
//         width: 15,
//             marginRight: theme.spacing(0.5),
//     },
// },
// displayField: {
//     margin: 0,
//         '&.body': {
//         fontSize: `1rem`,
//             lineHeight: 1.5,
//             fontWeight: 400,
//             // letterSpacing: 0.15,
//             color: `#18313a`,
//     },
//     '&.h1': {
//         fontSize: `2.5rem`,
//             lineHeight: 1.5,
//             fontWeight: 700,
//             // letterSpacing: 0.15,
//             color: `#2d2d2d`,
//     },
//     '&.h2': {
//         fontSize: `1.75rem`,
//             lineHeight: 1.25,
//             fontWeight: 600,
//             // letterSpacing: 0.15,
//             color: `#2d2d2d`,
//     },
//     '&.h3': {
//         fontSize: `1.25rem`,
//             lineHeight: 1.25,
//             fontWeight: 500,
//             // letterSpacing: 0.15,
//             color: `#2d2d2d`,
//     },
// },
// displayEditor: {
//     width: `100%`,
//         maxWidth: '600px',
//         // position: `-webkit-sticky`,
//         position: `sticky`,
//         bottom: 0,
//         // backgroundColor: theme.palette.common.white,
//         // padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
//         border: `none`,
//         borderRadius: theme.spacing(1),
//         display: `flex`,
//         justifyContent: 'center', // border: `1px solid red`,
//         flexWrap: `wrap`,
//         overflowX: 'hidden',
//         overflowY: 'hidden',
//
//     // '& .header': {
//     //     width: `100%`,
//     //     padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
//     //     backgroundColor: `#f4f4f4`,
//     //     fontSize: `0.75rem`,
//     //     letterSpacing: 0.25,
//     //     color: `#666`,
//     //     fontWeight: 500,
//     //     [theme.breakpoints.down('lg')]: {
//     //         maxWidth: `100%`,
//     //     },
//     // },
//     // '& button': {
//     //     marginRight: theme.spacing(2),
//     // },
//     // '&.noBorder': {
//     //     border: `none`,
//     //     backgroundColor: theme.palette.text[5],
//     // },
//     // '& .labelField': {
//     //     padding: theme.spacing(1.5),
//     //     '& span': {
//     //         color: `#2d2d2d`,
//     //         textTransform: 'capitalize',
//     //         fontWeight: 500,
//     //         fontSize: `0.875rem`,
//     //         lineHeight: `1.3125rem`,
//     //     },
//     // },
//     // '& p': {
//     //     color: `#7a7a7a`,
//     //     fontSize: `0.875rem`,
//     // },
// },
